import React, { Fragment, useState,useEffect, useContext } from 'react';
import { Row, Col, Modal, Button } from 'antd';
import moment from 'moment';
import Container from 'components/UI/Container/Container';
import Loader from 'components/Loader/Loader';
import Description from './Description/Description';
import Amenities from './Amenities/Amenities';
import Location from './Location/Location';
import Room from './Room/Room';
import TopBar from './TopBar/TopBar';
import PostImageGallery from './ImageGallery/ImageGallery';
import useMoreDataApi from 'library/hooks/useMoreDataApi';
import ImageGallery from 'react-image-gallery';
import {getLocalCurrency} from 'context/currency' ;
import {loadState} from 'library/helpers/localStorage' ;
import 'react-multi-carousel/lib/styles.css';
import SinglePageWrapper, { PostImage }  from './SinglePageView.style';
import Review from './Review/Review';
import { DAY_SEMAINE_OBJECT_NUMBER, DEFAULT_START_PAGE, LIMIT_SIZE_CHAMBRE_PAGINATION, LIMIT_SIZE_PAGINATION } from 'library/helpers/constUtils';
import { SharedDataContext } from 'context/SharedDataProvider';
import { NavLink, useParams, useNavigate } from 'react-router-dom';
import { LISTING_POSTS_PAGE } from 'settings/constant';
import Services from './Services/Services';


const SinglePage = () => {
  const { idHotel } = useParams();
  const [isModalShowing, setIsModalShowing] = useState(false);
  const [paramRoom, setParamRoom] = useState();
  const {isFiltreDayUseChecked, setIsFromDetail} = useContext(SharedDataContext);
  const navigate = useNavigate();

  const [currency, setCurrency] = useState(getLocalCurrency());
  useEffect(() => {
    window.addEventListener('storage', () => {
      if(getLocalCurrency()){
        setCurrency(getLocalCurrency());
      } 
    });
    }, []);

  let params = loadState("filtre") ? loadState("filtre") : null ;
  let hotel = [] ;
  let promoHotel =  [] ; 
  let chambreFiltreParam =
  (params && params.date_range.setEndDate && params.date_range.setStartDate )  ?  
  {
    "chambreTypeHerbergement": [],
    "dateDisponibiliteChambre": {
      "dateDepart": moment(params.date_range.setEndDate,'DD-MM-YYYY').format('YYYY-MM-DD'),
      "dateEntree": moment(params.date_range.setStartDate,'DD-MM-YYYY').format('YYYY-MM-DD')
    },
    "idHotel": idHotel,
    "nombreChambre": (params.room) ? params.room : 1 ,
    "nombreVoyageur": params.guest ? params.guest : 1 
  } : null;
  let url = [
    {
      url : `${process.env.REACT_APP_API_URL}/hotels/${idHotel}`,
      method : 'GET',
      body : {}
    },
    {
      url : `${process.env.REACT_APP_API_URL}/offre-promo/hotel/${idHotel}`,
      method : 'GET',
      body : {}
    },
  ] ;

  let { data, loading, error, errorMessage } = useMoreDataApi(url.map(item=>item.url),
                                                              url.map(item=>item.method),
                                                              url.map(item=>item.body));

  //var for chambre pagination
  const [chambreLoaded, setChambreLoaded] = useState([]);
  const [diplayLoadMoreBtn, setDiplayLoadMoreChambreBtn] = useState(true);
  const [diplayLoaderToLoadMoreChambreBtn, setDiplayLoaderToLoadMoreChambreBtn] = useState(false);
  const [loader , setLoader] = useState(false) ;
  let [pageChambreToLoad, setPageChambreToLoad] = useState(DEFAULT_START_PAGE);

  //simulate action reload chambre data  
  let [loadDataChambre, setLoadDataChambre] = useState(0);

  //increments when you click on load more
  const handleLoadMoreChambre = (defaultPage) => {
    setPageChambreToLoad(Number.isInteger(defaultPage) ? defaultPage : ++pageChambreToLoad);
    if (!Number.isInteger(defaultPage))
      setLoadDataChambre(++loadDataChambre);
  }

  //retrieve chambre list by filter && size
  //update chambreLoaded && display loadMoreBtn condition
  const getChambreList = () => {

    setDiplayLoaderToLoadMoreChambreBtn(true);

    if (chambreLoaded <= 0)
      setLoader(true);

    const urlData = chambreFiltreParam
    ? {
      url : `${process.env.REACT_APP_API_URL}/chambre-type-hebergements-filter`,
      method : 'POST',
      body : JSON.stringify(chambreFiltreParam)
    }
    : {
      url : `${process.env.REACT_APP_API_URL}/chambres-types-hebergements/hotel/${idHotel}/dispo`,
      method : 'GET'
    };

    const options = {
      method: urlData.method,
      headers: {'Content-type': 'application/json'}
    };

    
    if (urlData.method === 'POST') {
      options.body = urlData.body;
    }


    fetch(`${urlData.url}?page=${pageChambreToLoad}&size=${LIMIT_SIZE_CHAMBRE_PAGINATION}`, options)
      .then(
      resp => {
        if (resp.ok) {
          resp.json().then(
            data => {

              if (isFiltreDayUseChecked) {
                //get tarif per item
                data?.content.map((item) => {
                  if (Array.isArray(item.dayUses) && item.dayUses.length > 0) {
                    //update content item with dayUseTarif
                    let prixMinDayUseAriary = (item.dayUses[0].tarifs.find(tarif => tarif.idDevise == 1))?.prix ?? 0;
                    let prixMinDayUseEuro = (item.dayUses[0].tarifs.find(tarif => tarif.idDevise == 2))?.prix ?? 0;
    
                    for (let i = 1; i < item.dayUses.length; i++) {
                      const currentPrixAriary = item.dayUses[i].tarifs.find(tarif => tarif.idDevise == 1)?.prix ?? 0;
                      const currentPrixEuro = item.dayUses[i].tarifs.find(tarif => tarif.idDevise == 2)?.prix ?? 0;
                      if(prixMinDayUseAriary >  currentPrixAriary)
                        prixMinDayUseAriary = currentPrixAriary;

                      if(prixMinDayUseEuro >  currentPrixEuro )
                        prixMinDayUseEuro = currentPrixEuro;
                    }

                    item.prixDayUseAriary =  prixMinDayUseAriary;
                    item.prixDayUseEuro =  prixMinDayUseEuro;
                  }
                  
                  return item;
                })
              }


              setChambreLoaded([
                ...chambreLoaded,
                ...data.content ? data.content.sort((a, b) => a.typeHebergement > b.typeHebergement ? 1 : -1) : []
              ]);
    
              setDiplayLoadMoreChambreBtn(!data.last);
              setLoader(false);
              setDiplayLoaderToLoadMoreChambreBtn(false);
            }
          )
        } else {
          setDiplayLoaderToLoadMoreChambreBtn(false);
        }
      }
    )
  }

  // reload getChambreList when loadDataChambre value updated
  useEffect(() => {
    getChambreList();
  }, [loadDataChambre]);

  const handleBack = () => {
    setIsFromDetail(true)
    navigate(-1);
  };

  const modalError = (title, message) => {
    Modal.error({
      title: title,
      content: message,
      onOk() {
        return;
      }
    });
  };

  if (error){
    modalError('Détails hôtel', `Ooups ! Une erreur est survenue`);
    return ; 
  }
  if (data && (data.length== 0 || loading)) { 
    return <Loader />;
  }

  data.map(
    ({
      key,
      value
    }) => {
      switch (key) {
        case url[0].url:
          hotel = value ; 
          break;
        case url[1].url:
          promoHotel = value ; 
          break;
        default:
          break;
      }
    })
  const {
    description,
    nom,
    adresse,
    images,
    equipementHebergements,
    reperes,
    id,
    nombreChambreDispoMax,
    serviceHebergements
  } = hotel;
  
  let itemImages = [] ; 
  if (images){
    images.map( (u) => {
      itemImages.push({ "original" : `${process.env.REACT_APP_API_URL}/${u.url}` ,
       "thumbnail" : `${process.env.REACT_APP_API_URL}/${u.url}`})
    })
  }

  return (
    <SinglePageWrapper>
      <PostImage>

      <ImageGallery 
        items={itemImages}
        showPlayButton={false}
        showFullscreenButton={false}
        showThumbnails = {false}
        showIndex={true}
        lazyLoad={true}
        slideDuration={100}
        className="image_gallery_modal"
      />
        <Button
          type="primary"
          onClick={() => setIsModalShowing(true)}
          className="image_gallery_button"
        >
          Voir toutes les images
        </Button>
        <Modal
          open={isModalShowing}
          onCancel={() => setIsModalShowing(false)}
          footer={null}
          width="100%"
          maskStyle={{
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
          }}
          wrapClassName="image_gallery_modal"
          closable={false}
        >
          <Fragment>
            <PostImageGallery  images={itemImages}/>
            <Button
              onClick={() => setIsModalShowing(false)}
              className="image_gallery_close"
            >
              <svg width="16.004" height="16" viewBox="0 0 16.004 16">
                <path
                  id="_ionicons_svg_ios-close_2_"
                  d="M170.4,168.55l5.716-5.716a1.339,1.339,0,1,0-1.894-1.894l-5.716,5.716-5.716-5.716a1.339,1.339,0,1,0-1.894,1.894l5.716,5.716-5.716,5.716a1.339,1.339,0,0,0,1.894,1.894l5.716-5.716,5.716,5.716a1.339,1.339,0,0,0,1.894-1.894Z"
                  transform="translate(-160.5 -160.55)"
                  fill="#909090"
                />
              </svg>
            </Button>
          </Fragment>
        </Modal>
      </PostImage>
      <TopBar title={nom} />
      <Container>
        <Row gutter={30} id="reviewSection" style={{ marginTop: 30 }}>
          <Col xl={24}>
            <Description
              content={description}
              title={nom}
              location={adresse}
            />
            <Amenities data={equipementHebergements} />
            <Services data={serviceHebergements} />
            <Location location={hotel} images={itemImages} />
          </Col>
        </Row>
        {
        loader ? <Loader/> : 
        <Room 
          details ={chambreLoaded} 
          currency={currency} hotel={idHotel} 
          roomMax={nombreChambreDispoMax}
          setParamRoom={setParamRoom}
          paramRoom={paramRoom}
          diplayLoadMoreBtn={diplayLoadMoreBtn}
          loadMoreChambre={handleLoadMoreChambre}
          setDiplayLoadMoreChambreBtn={setDiplayLoadMoreChambreBtn}
          setChambreLoaded={setChambreLoaded}
          diplayLoaderToLoadMoreChambreBtn={diplayLoaderToLoadMoreChambreBtn}
          remises={promoHotel}
          />
        }
        <div style={{textAlign:"center", marginTop:"-20px",marginBottom:"20px"}}>
          <Button onClick={handleBack} type='primary' style={{marginRight:"10px"}}> {"<< Retour"}</Button>
        </div>
        <div className='reviews-block'>
              <Review
                displayAddBtn={true}
                displayDetail={true}
                idHotel={idHotel}
              />
        </div>
        
      </Container>
    </SinglePageWrapper>
  );
};

export default SinglePage;
